import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el PROFEPACK después de comprar?',
  answer: 'Inmediatamente después de confirmar tu pago recibís un email con el enlace de descarga de todos los PDFs. En menos de 5 minutos tenés los 12 tomos y los 6 bonos disponibles para empezar a usar.'
}, {
  question: '2 — ¿Sirve para mi provincia o solo para Buenos Aires?',
  answer: 'Sirve para todo el país. Cada tomo está alineado a los NAP federales y contempla los Diseños Curriculares de las principales jurisdicciones: Buenos Aires, Córdoba, Santa Fe, Mendoza, Tucumán y más.'
}, {
  question: '3 — ¿Es editable? ¿Puedo modificarlo?',
  answer: 'Los tomos están en PDF de alta calidad, listos para usar e imprimir. No son editables para mantener la coherencia y calidad del material. Podés imprimirlos completos o página por página según lo que necesites.'
}, {
  question: '4 — ¿Los 6 bonos están en todas las ofertas?',
  answer: 'Sí, sin excepción. Ya sea que compres Primaria, Secundaria o el Pack Completo, los 6 bonos estratégicos están incluidos sin costo adicional.'
}, {
  question: '5 — ¿Puedo comprar Primaria ahora y Secundaria después?',
  answer: 'Sí. Podés empezar con el nivel que más necesitás y sumar el otro después. El Pack Completo es la opción más conveniente si enseñás en ambos niveles porque incluye todo con el mayor descuento.'
}, {
  question: '6 — ¿Sirve si soy docente con poca experiencia?',
  answer: 'Es ideal para docentes nuevas. Las secuencias didácticas están diseñadas paso a paso — con inicio, desarrollo y cierre claros — para que cualquier docente pueda usarlas con confianza desde el primer día.'
}, {
  question: '7 — ¿Sirve para cursos difíciles o con mucho desorden?',
  answer: 'Sí. Las 30 Clases Salvavidas del Bono 2 están especialmente diseñadas para grupos complejos: actividades con consignas claras, breves y con estructura firme que generan orden y participación incluso en los grupos más difíciles.'
}, {
  question: '8 — ¿Está actualizado al currículo vigente?',
  answer: 'Sí. Cada tomo está alineado a los NAP vigentes de Lengua y Literatura y a los Diseños Curriculares actualizados. La bibliografía oficial incluida al final de cada tomo lo certifica.'
}, {
  question: '9 — ¿Tiene garantía real?',
  answer: 'Sí, completamente real. Tenés 7 días para revisar todo el material. Si por cualquier motivo no cumple tus expectativas, te devolvemos el 100% del dinero. Sin preguntas, sin formularios, sin condiciones.'
}, {
  question: '10 — ¿Qué diferencia tiene PROFEPACK con otros packs que vi?',
  answer: 'La diferencia es total. La mayoría de los materiales que circulan son planificaciones sueltas, fichas sin secuencia o recursos que no están alineados al currículo argentino. PROFEPACK es el único sistema que cubre los 12 años del trayecto escolar en Lengua y Literatura con planificación anual, secuencias completas, evaluaciones, rúbricas Y solucionario integrado en cada tomo. No hay otro igual.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-74">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-75">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-white/30 bg-[#0a100d]' : 'border-white/10 bg-black'}`} data-id="element-76">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-77">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-78">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#33BFA6] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-79">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-80">
                  <div className="h-px bg-white/10 mb-4" data-id="element-81" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-82">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}